import {
  SET_ANNOUCEMENT,
  EDIT_ANNOUCEMENT,
  REMOVE_ANNOUCEMENT,
} from "./actionType";

export default function reducer(state = [], action) {
  switch (action.type) {
    case SET_ANNOUCEMENT:
      return [...action.payload];
    case EDIT_ANNOUCEMENT:
      return state.map((m, index) => {
        if (index === Number(action.index))
          return {
            ...action.payload,
          };
        else return m;
      });
    case REMOVE_ANNOUCEMENT:
      return [
        ...state.slice(0, action.index),
        ...state.slice(action.index + 1),
      ];
    default:
      return state;
  }
}
